import React, { useRef } from "react";
import Lottie from 'lottie-react';
import loadingJson from "../../assets/loading_data.json";
const Connection = ({  }) => {
    const lottieRef = useRef(null);
    const handleComplete = () => {
        console.log('Animation Completed');
      };
    return (
        <div className="connection_loading" style={{ width:'100%',height:'100%',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',position: 'absolute',top: 0,background: '#00000070',zIndex:'100' }}>
            <div style={{ width:'150px',height:'150px',marginLeft:'-25px'}}>
                <Lottie
                    animationData={loadingJson}
                    loop={true}
                    autoplay={true}
                    lottieRef={lottieRef}
                    onComplete={handleComplete}
                />
            </div>
        </div>
    )
}
export default Connection;